import { Suspense, lazy } from 'react'
import type {
  BankFlagsProps,
  CreditCardFlagsProps,
  PaymentMethodFlagsProps,
} from './flags.types'

const BankFlags = lazy(() => import('./variants/BankFlags'))
const CreditCardFlags = lazy(() => import('./variants/CreditCardFlags'))
const PaymentMethodFlags = lazy(() => import('./variants/PaymentMethodFlags'))

export const Flags = {
  Banks: (props: BankFlagsProps) => (
    <Suspense fallback={null}>
      <BankFlags size={props.size ?? 'sm'} variant={props.variant} />
    </Suspense>
  ),
  CreditCards: (props: CreditCardFlagsProps) => (
    <Suspense fallback={null}>
      <CreditCardFlags size={props.size ?? 'sm'} variant={props.variant} />
    </Suspense>
  ),
  PaymentMethods: (props: PaymentMethodFlagsProps) => (
    <Suspense fallback={null}>
      <PaymentMethodFlags
        size={props.size ?? 'sm'}
        variant={props.variant}
        disabled={props.disabled}
      />
    </Suspense>
  ),
}
